const home = { home: 'Home' };
export default home;
